import { Routes, useLocation } from "react-router-dom";
import { Image } from "@common/components";
import { useAuthStore } from "@domains/auth/utils/useAuthStore";
import { useEffect, useState } from "react";
import { AuthenticatedRoutes } from "./routes/AuthenticatedRoutes";
import { Toaster } from "./components/ui/toaster";
import posthog from "posthog-js";
import { TooltipProvider } from "./components/ui/tooltip";
import { ReasonDialog } from "@common/components/ReasonDialog";
import { LoggedOutAuthRoutes } from "@domains/auth";

export const App = () => {
  const isRefreshTokenExpired = useAuthStore((state) =>
    state.isRefreshTokenExpired(),
  );
  const [reason, setReason] = useState<string>("");

  const location = useLocation();
  useEffect(() => {
    posthog.capture("$pageview");
  }, [location]);

  const handleSetReason = (reason?: string) => {
    setReason(reason || "");
    return !!reason;
  };

  return (
    <ReasonDialog reason={reason}>
      <Toaster setReason={handleSetReason}>
        <TooltipProvider>
          <div className="fixed inset-0 -z-10 w-full bg-black">
            <Image name="background-glass" className="ml-auto h-full" />
          </div>
          {isRefreshTokenExpired ? (
            <Routes>{LoggedOutAuthRoutes}</Routes>
          ) : (
            <AuthenticatedRoutes />
          )}
        </TooltipProvider>
      </Toaster>
    </ReasonDialog>
  );
};
